import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SocialWorkerSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titleSocialWorker
      }
    >
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="social_worker_last_name"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerName
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="social_worker_first_name"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerFirstName
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="social_worker_telephone"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerPhone
          }
          textInputType="tel"
        />
      </SectionRow>

      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="social_worker_fax"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerFax
          }
          textInputType="tel"
        />
        <TextInputWithLabel
          bold
          elementName="social_worker_email"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .socialWorkerEmail
          }
          large
        />
      </SectionRow>
    </Section>
  );
};
